import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { path as d3path } from 'd3-path';
import { applyStyle } from '../utils';
import { select } from '../../utils/selection';
/**
 * Connect 2 points with a smooth line, used in tree.
 */
export var Smooth = function Smooth(options, context) {
  var style = __rest(options, []);
  var document = context.document;
  return function (points, value, defaults) {
    var defaultColor = defaults.color,
      rest = __rest(defaults, ["color"]);
    var _value$color = value.color,
      color = _value$color === void 0 ? defaultColor : _value$color,
      transform = value.transform;
    var _points = _slicedToArray(points, 2),
      from = _points[0],
      to = _points[1];
    var path = d3path();
    path.moveTo(from[0], from[1]);
    path.bezierCurveTo(from[0] / 2 + to[0] / 2, from[1], from[0] / 2 + to[0] / 2, to[1], to[0], to[1]);
    return select(document.createElement('path', {})).call(applyStyle, rest).style('d', path.toString()).style('stroke', color).style('transform', transform).call(applyStyle, style).node();
  };
};
Smooth.props = {
  defaultMarker: 'smooth',
  defaultEnterAnimation: 'fadeIn',
  defaultUpdateAnimation: 'morphing',
  defaultExitAnimation: 'fadeOut'
};